module.exports = __webpack_public_path__ + "static/media/matilde-hat-greece-sad.0cddaf9f.png";